import { type ReactNode } from 'react'

type SectionHeaderProps = {
  label: string
  icon: ReactNode
  heading: string
  color?: string
  className?: string
}

export const SectionHeader = ({
  label,
  icon,
  heading,
  color = 'inc-primary-10',
  className = ''
}: SectionHeaderProps) => {
  return (
    <div className={`text-center space-y-3 ${className}`}>
      <p
        className={`flex items-center justify-center gap-2 text-xs md:text-sm font-extrabold uppercase text-${color}`}
      >
        {label}
        {icon}
      </p>
      <h2
        className="text-2xl md:text-4xl"
        dangerouslySetInnerHTML={{ __html: heading }}
      />
    </div>
  )
}

export default SectionHeader
